import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import axios from 'axios';
import * as Yup from 'yup';
import {
  AppTextArea,
} from '@/layout/AppComponents';
import { axiosPath } from '../../../../../../routing/helpers/router';
import useIsMounted from '../../../../../components/hooks/useIsMounted';
import errorHandler from '@/layout/components/error/ErrorHandler';

export default function InecoRiskManagerRiskKpiForm({
  riskID,
  goalID,
  kpiID,
  kpi,
  onShowDeleteKpiModal,
  onCloseModals,
  onReloadTab,
}) {
  const { moduleBridgeHex } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const validationSchema = Yup.object().shape({
    description: Yup.string().required('Requerido'),
  });

  // > SAVE
  const handleSave = useCallback(
    async (values) =>
      axios
        .post(
          axiosPath(
            kpiID === 0
              ? "api_r_user_module_inecoRiskManager_risk_kpi_add"
              : "api_r_user_module_inecoRiskManager_risk_kpi_edit"
          ),
          {
            moduleBridgeHex,
            riskID,
            goalID,
            kpiID,
            ...values,
          }
        )
        .then(() => {
          if (isMounted.current) {
            onCloseModals();
            onReloadTab();
          }
        })
        .catch((e) => dispatch(errorHandler(e))),
    [moduleBridgeHex, riskID, goalID, kpiID]
  );
  // < SAVE

  return (
    <Formik
      validateOnChange={false}
      validateOnBlur={false}
      validationSchema={validationSchema}
      initialValues={{
        description: kpi?.description || '',
        result: kpi?.result || '',
        keyResults: kpi?.keyResults || '',
      }}
      onSubmit={handleSave}
    >
      {({ setFieldValue, handleSubmit, values, errors, isSubmitting }) => (
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-12">
              <AppTextArea
                title="KPI"
                onChange={(v) => setFieldValue('description', v)}
                value={values.description}
                error={errors.description}
                resize
                height="240px"
                isClearable
                required
              />
            </div>
            <div className="col-12">
              <AppTextArea
                title="Resultado KPI"
                onChange={(v) => setFieldValue('result', v)}
                value={values.result}
                error={errors.result}
                resize
                height="240px"
                isClearable
              />
            </div>
            <div className="col-12">
              <AppTextArea
                title="Key Results"
                onChange={(v) => setFieldValue('keyResults', v)}
                value={values.keyResults}
                error={errors.keyResults}
                resize
                height="240px"
                isClearable
              />
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-12">
              <button
                type="submit"
                className="btn btn-sm btn-success float-right"
                disabled={isSubmitting}
              >
                {kpiID !== 0 ? 'Editar' : 'Crear'}
              </button>
              {kpiID !== 0 && (
                <button
                  type="button"
                  className="btn btn-sm btn-danger float-right mr-2"
                  onClick={() => onShowDeleteKpiModal(kpiID)}
                >
                  Eliminar
                </button>
              )}
              <button
                type="button"
                className="btn btn-sm btn-outline-danger float-right mr-2"
                onClick={onCloseModals}
              >
                Cancelar
              </button>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}
